import React from 'react'

import { popupFactory } from '@/factories'

import { StripePaymentModal } from './stripe-payment-modal'
import { StripePaymentButtonProps } from './stripe-payment-modal.types'

export const StripePaymentButton = ({
  amount,
  description,
  email,
  context,
  onPaymentSuccess,
  onPaymentError,
  buttonLabel,
  className,
  disabled,
  pending,
  style,
}: StripePaymentButtonProps) => {
  const handleClick = () => {
    popupFactory.open(StripePaymentModal, {
      amount,
      context,
      description,
      email,
      onPaymentError,
      onPaymentSuccess,
    })
  }

  return (
    <button
      disabled={disabled}
      style={style}
      className={`${className || 'button button-primary ctp-payment-button'} ${pending ? 'is-loading' : ''}`}
      onClick={handleClick}
    >
      {buttonLabel || `Join Lesson for $${amount}`}
    </button>
  )
}
